
















import { Search } from '~/models/search/types'
import SearchBucketService from '~/services/search-bucket/SearchBucketService'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useRouter
} from '@nuxtjs/composition-api'
import { useDep } from '~/compositions/dependency-container'
import { useLogger } from '~/compositions/logger'
import {
  QUICK_SEARCH_NS,
  QuickSearchState
} from '~/store/modules/shared/quickSearch/state'
import { useNamespacedStore } from '~/compositions/store'
import { timeDistanceFromNow } from '~/utils/date'
import CFormSelectOption from '~/components/shared/configurable/form/select/CFormSelectOption.vue'

export default defineComponent({
  components: {
    CCustomSelect,
    CFormSelectOption
  },
  setup(_, { emit }) {
    const selectedRecentSearch = ref<string | null>(null)
    const loading = ref(false)
    const recentSearches = ref(new Map())

    const searchBucketService = useDep(SearchBucketService)
    const logger = useLogger()
    const router = useRouter()

    const { getters } = useNamespacedStore<QuickSearchState>(QUICK_SEARCH_NS)

    onMounted(async () => {
      loading.value = true
      try {
        recentSearches.value = await searchBucketService.getRecentSearchesForCategory(
          rootCategoryId.value
        )
      } catch (error) {
        logger.captureError(error as any)
      } finally {
        loading.value = false
        if (recentSearches.value.size) {
          emit('has-results')
        }
      }
    })

    const rootCategoryId = computed(() => getters('rootCategoryId'))
    const options = computed(() =>
      [...recentSearches.value.values()].map((s: Search) => ({
        text: `${s.title} (${timeDistanceFromNow(s.creationDate, {
          includeSeconds: true
        })})`,
        value: s.id
      }))
    )

    function handleSearchSelect(id: string) {
      selectedRecentSearch.value = id
      const selectedSearch: Search = recentSearches.value.get(id)

      const searchUrl = router.resolve({
        name: '__classifieds_search_plot'
      })

      if (selectedSearch && selectedSearch.legacyListingsUrl) {
        router.push(selectedSearch.legacyListingsUrl)
      } else {
        selectedSearch &&
          selectedSearch.query &&
          searchUrl &&
          router.push(searchUrl.href + '?' + selectedSearch.query)
      }
    }

    return { options, selectedRecentSearch, handleSearchSelect }
  }
})
